<template>
  <div class="flex md:justify-between flex-col-reverse md:flex-row">
    <section class="bg-white p-4 md:p-8 lg:p-10 lg:w-1/3 rounded-lg step">
      <h3 class="lg:text-3xl leading-normal font-semibold">
        Now organize your board journey steps
      </h3>
      <p class="text-lg mt-4 lg:mt-6" style="color: #a8a8a8">
        All list a bundle of card that represent journey. Customize your journey
        steps and add as many as you’d like.
      </p>

      <div class="flex flex-col mt-4 lg:mt-6" style="color: #3c3c3c">
        <p class="text-xl md:text-2xl font-normal">Enter journey steps name</p>
        <div class="my-2" v-for="(inputField, i) in inputFields" :key="i">
          <div class="step-box max-w-xs p-4 flex items-center justify-between">
            <input
              class="w-full max-w-xs text-xl border-0"
              :class="missingStepAt === i ? 'error-input' : ''"
              :placeholder="inputField.placeHolder"
              v-model="inputField.stepName"
            />
            <img
              src="@/assets/images/boards/cross-boards.svg"
              alt="cross icon"
              class="cursor-pointer"
              @click="removeStep(i)"
            />
          </div>

          <p
            v-if="missingStepAt === i"
            class="text-lg font-normal error-text mt-1"
          >
            Enter step name
          </p>
        </div>

        <div
          class="w-full max-w-xs rounded-lg text-xl mt-4 bg-transparent text-left p-3 addField cursor-pointer"
          @click="addBoardStep"
        >
          + Add more steps
        </div>
        <vs-button
          class="w-1/3 rounded-lg text-xl mt-4"
          @click="routeToStepThree"
          :color="orgData.primaryThemeColor"
          >Next</vs-button
        >
      </div>

      <div class="mt-6 flex justify-between">
        <p
          class="flex items-center text-lg md:text-xl cursor-pointer"
          style="color: #a8a8a8"
          @click="
            $router.push(
              `/organization/${orgData.slug}/create-board/${$route.params.boardId}`
            )
          "
        >
          <img src="@/assets/images/icons/arrow-left-grey.svg" alt="Back" />
          Back
        </p>
        <p class="text-lg md:text-xl cursor-pointer" style="color: #a8a8a8">
          Skip
        </p>
      </div>
    </section>

    <section
      class="mb-6 md:mb-0 md:ml-8 bg-white p-4 md:p-8 lg:p-10 lg:w-2/3 rounded-lg step"
    >
      <BoardSkeletonVue />
    </section>
  </div>
</template>

<script>
import BoardSkeletonVue from "./component/BoardSkeleton.vue";
import commonMixin from "./mixins/commonMixin";

export default {
  data() {
    return {
      inputFields: [
        { stepName: "", placeHolder: "e.g: On Board" },
        { stepName: "", placeHolder: "e.g: Doing" },
        // { stepName: "", placeHolder: "e.g: Done" },
      ],
      missingStepAt: -1,
    };
  },
  components: {
    BoardSkeletonVue,
  },
  mixins: [commonMixin],
  watch: {
    kanbanData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.cols) {
          this.inputFields = newVal.cols.map((field) => {
            const { title } = field;
            return {
              stepName: title,
              placeHolder: title,
            };
          });
        }
      },
    },
  },
  mounted() {
    this.getKanbanBoardDetails(this.$route.params.boardId);
  },
  methods: {
    addBoardStep() {
      this.inputFields.push({ stepName: "", placeHolder: "Enter Step" });
    },
    validateStepName() {
      for (let i = 0; i < this.inputFields.length; i++) {
        if (!this.inputFields[i].stepName) {
          return (this.missingStepAt = i);
        } else {
          this.missingStepAt = -1;
        }
      }
    },
    routeToStepThree() {
      this.validateStepName();
      if (this.missingStepAt === -1) {
        let boardId = this.$route.params.boardId;
        this.$store
          .dispatch("kanban/updateKanbanV2", {
            boardId: boardId,
            cols: this.inputFields.map((field) => ({
              title: field.stepName,
            })),
          })
          .then((res) => {
            if (res && res.data && res.data.data && res.data.data._id) {
              this.$router.push(
                `/organization/${this.orgData.slug}/create-board/${boardId}/step3`
              );
            }
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    getKanbanBoardDetails(boardId) {
      this.$store.dispatch("kanban/getKanbanDataV2", boardId);
    },
    removeStep(stepToBeRemove) {
      this.inputFields.splice(stepToBeRemove, 1);
      this.$store.commit(
        "kanban/SET_KANBAN_COL_DATA",
        this.inputFields.map((field) => ({
          title: field.stepName,
        }))
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles/step-common.scss";

.addField {
  border-radius: 12px;
  border: 2px solid #e8ebed;
  color: #a8a8a8;
}
</style>
